import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { OpalApiResponseDocument } from '@opallabs/api'

type ShallowCategory = OpalApiResponseDocument<
  'ExperimentalReadBlockBFFV1',
  200
>['data']['details']['category']

export const shallowCategoryFactory: Factory<ShallowCategory> =
  Factory.define<ShallowCategory>(
    ({ sequence }) =>
      ({
        id: uuidV4(),
        title: `Swimlane ${sequence}`,
        ancestor_titles: [`Swimlane Group ${sequence}`],
      }) satisfies ShallowCategory
  )
